module.exports = __webpack_public_path__ + "static/img/service3.fcdc32ad.png";